import { render } from "./ViewLanding.vue?vue&type=template&id=025cf744"
import script from "./ViewLanding.vue?vue&type=script&lang=js"
export * from "./ViewLanding.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__